// ************************************************************************************************
//
// TODO: Each element in this file is a hacky workaround to meet client requirements in other
// applications outside of this one, and should eventually be replaced with functionality in either
// the public facing bpor API or the parts of the application stored on dotCMS.
//
// ************************************************************************************************

import { addId } from '@/utilities/functions'
import api from '@/utilities/api'
import { MOBILE_WIDTH } from './constants'

export const alterHeaderSearchValue = v => {
  keepLookingForElementThenSetValueOnce('.keyword-search-field .autocomplete__input', v)
}

export const alterMobileHeaderSearchValue = v => {
  keepLookingForElementThenSetValueOnce('#keyword-search-field-hold', v)
  keepLookingForElementThenSetValueOnce('.keyword-search-field-mobile .autocomplete__input', v)
}

export const emptyFetch = async context =>
  await api('/json-params/cd', {
    data: { ...context.$store.getters['search/params'], offset: 0, rows: 1 },
    json: true,
    method: 'POST',
    prefix: 'search',
  })

export const keepLookingForElementThenRunCallbackOnce = (q, callback, t = 100, count = 0) => {
  const el = document.querySelector(q)
  // console.log('el, q, v, t, c', el, q, callback, t, count)
  if (count >= 300) return
  else if (el) callback(el)
  else
    setTimeout(() => {
      keepLookingForElementThenRunCallbackOnce(q, callback, t, ++count)
    }, t)
}

export const keepLookingForElementThenSetValueOnce = (q, v, t, c) => {
  const callback = el => {
    el.value = v
    postSetValueActions()
  }
  keepLookingForElementThenRunCallbackOnce(q, callback, t, c)
}

export const parseAgeRange = ar => (ar.match(/N\/A/g)?.length > 1 ? 'All' : ar)

const postSetValueActions = () => {
  const c =
    window.innerWidth > MOBILE_WIDTH ? '.keyword-search-field' : '.keyword-search-field-mobile'
  const q = `${c} .autocomplete__wrapper .autocomplete__menu--visible`
  const callback = el => {
    if (el?.classList?.contains('autocomplete__menu--visible')) {
      el.classList.remove('autocomplete__menu--visible')
      el.classList.add('autocomplete__menu--hidden')
    }
  }
  keepLookingForElementThenRunCallbackOnce(q, callback, 50, 20)
}

export const removeCategorizerBlankReferences = healthCategoryAndTags => {
  const badNames = ['CATEGORISER_BLANK', 'categoriser_blank']
  return addId(
    healthCategoryAndTags
      ?.map(c => ({
        count: c.count,
        name: c.category,
        tags: addId(
          c.tags
            ?.map(t => ({
              count: t.count,
              text: t.name,
              value: t.name,
            }))
            .filter(f => !badNames.includes(f.name)) || []
        ),
      }))
      .filter(f => !badNames.includes(f.name)) || []
  )
}
